import Vue from 'vue';
import Vuex from 'vuex';
import firebase from '@/firebase.js';
import PersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [PersistedState({ storage: window.sessionStorage })],
    state: {
        isLogin: false,
        catalogs: [],
        users: [],
        user: {
            userid: '',
            password: '',
            valid: 0
        },
        viewparam: {
            catalog: null,
        },
        loginDateTime: null,
        status: false
    },
    mutations: {
        onAuthStateChanged(state, user) {
            state.user = user; //firebaseが返したユーザー情報
        },
        onUserStatusChanged(state, status) {
            state.status = status; //ログインしてるかどうか true or false
        },

        initUsers(state) {
            /*   if (state.users.length < 1) {
                state.users = firebase.getUsers();
            }    */
            state.users = [];
            let uPromise = firebase.getUsers();
            uPromise.then(function(resolve) {
                state.users = resolve;
            })
        },

        initCatalogs(state) {
            state.catalogs = [];
            let cPromise = firebase.getCatalogs();
            cPromise.then(function(resolve) {
                state.catalogs = resolve;
            })
        },

        updateCatalog(state, payload) {
            payload.item.valid = 0;
            let uPromise = firebase.updateCatalog(payload.item);
            uPromise.then(); // 戻り値がないので
            /*
            uPromise.then(function(resolve) {
                if (resolve) {
                    return true;
                }
            });
            */
        },

        addCatalog(state, payload) {
            firebase.addCatalog(payload.item);
            /*
            if (key) {
                state.catalogs = [];
                state.catalogs = firebase.getCatalogs();
            }
            */
        },
        /*-------------------------------------------------
         logical delete : valid = 3 
        ---------------------------------------------------*/
        deleteCatalog(state, payload) {
            let dPromise = firebase.deleteCatalog(payload.item);
            dPromise.then(function(resolve) {
                if (resolve) {
                    let di1 = firebase.deleteCatalogImage(payload.item.file1);
                    di1.then();
                    let di2 = firebase.deleteCatalogImage(payload.item.file2);
                    di2.then();
                }
            });
        },
        /*
        deleteImage(state, payload) {
            firebase.deleteCatalogImage(payload.item);
        },
        */
        setLogin(state, payload) {
            if (payload.item.login) {
                state.user.userid = payload.item.userid;
                state.user.password = payload.item.password;
                state.user.valid = payload.item.valid;
                state.loginDateTime = new Date().toISOString().substr(0, 10);
                state.isLogin = true;
            } else {
                state.isLogin = false;
            }
        },

        setViewParams(state, payload) {
            state.viewparam.catalog = payload.item;
        },
    },

    getters: {
        user(state) {
            return state.user;
        },
        isLogin(state) {
            return state.isLogin;
        },
    },
    actions: {
        setLogin(context, item) {
            context.commit('setLogin', { item });
        },
        getCatalogAll(context) {
            let prm = new Promise(() => {
                context.commit('initCatalogs');
            });
            prm.then(); // waiting For the Result
        },
        updateCatalog(context, item) {
            let uP = new Promise(() => {
                context.commit('updateCatalog', { item });
            });
            uP.then(); // waiting For the Result
        },
        addCatalog(context, item) {
            let aC = new Promise(() => {
                context.commit('addCatalog', { item });
            });
            aC.then(); // waiting For the Result
        },
        deleteCatalog(context, item) {
            let dC = new Promise(() => {
                context.commit('deleteCatalog', { item });
            });
            dC.then(); // waiting For the Result
        },
        setViewParams(context, item) {
            let sV = new Promise(() => {
                context.commit('setViewParams', { item });
            });
            sV.then();
        },
    }
});